// TrackReadonlyContext.tsx
import { createContext, useContext } from 'react';

const ReadonlyContext = createContext<{
  readonly: boolean;
}>({ readonly: false });

export const ReadonlyProvider = ReadonlyContext.Provider;

export const useReadonlyContext = () => useContext(ReadonlyContext);